<template>
  <div class="commonProcess">
    <ul v-if="processData.length > 0">
      <li v-for="(item,index) in processData" :key="index" class="clear">
        <div class="stepLines">
          <div class="ball" :class="isActive(item,index)" />
          <div class="lines" v-if="index !== processData.length-1 || item.details" />
        </div>
        <div class="main">
          <div class="title">
            <!-- index !== processData.length - 1 -->
            <span v-if="item.title && item.name">{{ item.title }}（{{ item.name }}）</span>
            <span v-else>{{ item.name }}</span>
          </div>
          <!-- index !== processData.length - 1 -->
          <div class="details" v-if="item.type">
            <p class="top">
              <span v-if="item.type === $t('btn.Agree') || item.type === $t('btn.Rejected')" :class="item.type === '同意' ? 'agree' : 'reject'">{{ item.type }}</span>{{ item.details }}
            </p>
            <p class="bottom" v-if="item.time">
              {{ item.time }}
            </p>
          </div>
          <div class="nullStyle" v-else />
        </div>
      </li>
    </ul>
    <div v-else>暂无审批流程~</div>
  </div>
</template>

<script>
export default {
  name: 'CommonProcess',
  data () {
    return {

    };
  },
  props: {
    processData: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  methods: {
    isActive (item, index) {
      if (this.processData.length - 1 === index) {
        if (item.active) {
          return 'active';
        }
        return '';
      } else {
        return 'active';
      }
      // processData.length-1 === index && item.active ? '' : 'active'
    }
  }
};
</script>

<style lang="scss" scoped>
.commonProcess{
  min-height: 200px;
  position: relative;
  >ul{
    >li{
      position: relative;
      >.stepLines{
        width: 10px;
        height: 100%;
        position: absolute;
        top: 4px;
        bottom: 0;
        >.ball{
          width: 10px;
          height: 10px;
          background: #C8CDD6;
          border-radius: 50%;
        }
        >.active{
          background: #17A58A;
        }
        >.lines{
          width: 1px;
          border-left: 1px dashed #12927A;
          margin: 0 auto;
          height: 100%;
          //background: #EBEEF5;
        }
      }
      >.main{
        width: 100%;
        padding-left: 32px;
        padding-right: 20px;
        float: left;
        >.title{
          width: 100%;
          line-height: 20px;
          font-size: 16px;
          color: #313D4A;
        }
        >.details{
          width: 100%;
          min-height: 80px;
          margin: 16px 0;
          padding: 16px;
          background: #F3F5F8;
          line-height: 22px;
          color: #424C57;
          >.top{
            >span{
              margin-right: 6px;
            }
            >.agree{
              color: #3384FE;
            }
            >.reject{
              color: #F5222D;
            }
          }
          >.bottom{
            margin-top: 6px;
            >span{
              margin: 0 4px;
            }
          }
        }
        >.nullStyle{
          width: 100%;
          padding: 16px;
        }
      }
    }
  }
  >div{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%);
  }
}
</style>
